<template>
  <div>
    <div
        :class="[
        !isMiniWindows ? (active_nav != 0 ? 'isHover' : '') : '',
        !isMiniWindows && isHide ? 'isHide' : '',
      ]"
        class="nav_father white_bg"
        id="nav_father"
        @mouseenter="navEnter()"
        @mouseleave="navLeave()"
    >
      <!-- <div class="nav_search">
        <el-autocomplete
          size="medium"
          :placeholder="$t('搜索')"
          suffix-icon="el-icon-search"
          clearable
          v-model="input"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @select="searchAll"
          @clear="hideSearchDiv()"
          @blur="hideSearchDiv()"
          v-show="showSearch"
        >
        </el-autocomplete>
        <img
          :src="require('../../../static/img/search_icon.png')"
          @click="showSearchDiv()"
          v-show="!showSearch"
        />
        <img
          :src="
            language == 'zh'
              ? require('../../../static/img/language_en.png')
              : require('../../../static/img/language_cn.png')
          "
          @click="selectlang"
        />
      </div> -->
      <div
          class="my_nav"
          :class="[
          pcBarOpenState ? 'pcBarOpen' : '',
          navMenuIndex != -1 || pcBarOpenState ? 'border' : '',
        ]"
      >
        <div class="nav_logo_div" @mouseenter="navLeave()">
          <img
              @click="navto('/')"
              :src="
              !isMiniWindows
                ? require('../../../static/img/logo.png')
                : navEnterState || showWhiteNav
                ? require('../../../static/img/logo.png')
                : require('../../../static/img/logo.png')
            "
          />
          <!-- <img
            @click="navto('/')"
            :src="require('../../../static/img/logo.png')"
          /> -->
          <!-- <p>{{ imgs[30].url }}</p> -->
        </div>
        <div class="ul_div">
          <ul
              id="ul_header"
              @mouseleave="navMenuLeave()"
              :class="$i18n.locale != 'zh' ? 'en' : ''"
              :data-locale="$i18n.locale"
          >
            <li
                :class="[
                active_nav == i ? 'active' : '',
                pcBarOpenState ? 'en' : '',
              ]"
                class="nav_home"
                v-for="(item, i) in nav_title_list"
                :key="item.title"
            >
              <a
                  :id="'ul_header' + i"
                  @mouseenter="navMenuEnter(i)"
                  @click="navto(item.path)"
              >{{ item.title }}</a
              >
            </li>
          </ul>
          <div class="icon-li">
            <p>
              <span @click="pcBarOpen()" v-if="pcBarOpenState">{{
                  $t("关闭")
                }}</span>
            </p>
            <div class="language-switcher" v-if="!pcBarOpenState">
              <img
                  class="lang-icon"
                  src="../../../static/img/语言切换图标.png"
                  @click="toggleLangDropdown"
              />
              <div class="lang-dropdown" v-show="showLangDropdown">
                <div class="lang-option" @click="selectlang('en')">English</div>
                <div class="lang-option" @click="selectlang('zh')">简体中文</div>
                <div class="lang-option" @click="selectlang('es')">español</div>
              </div>
            </div>
            <img
                v-if="isMiniWindows"
                @click="!isMiniWindows ? pcBarOpen() : openSider()"
                :src="pcBarOpenState || drawer ? barCloseImg : barMenuImg"
            />
          </div>
        </div>
        <!-- <div class="sider-img-div">
          <img
            class="sider-img2"
            :src="
              navEnterState || showWhiteNav
                ? language == 'zh'
                  ? require('../../../static/img/language_en.png')
                  : require('../../../static/img/language_cn.png')
                : language == 'zh'
                ? require('../../../static/img/language_en_w.png')
                : require('../../../static/img/language_cn_w.png')
            "
            @click="selectlang"
          />
          <img
            class="sider-img"
            :src="
              drawer
                ? sider_close_img
                : navEnterState || showWhiteNav
                ? sider_open_img2
                : sider_open_img
            "
            @click="openSider"
          />
        </div> -->
      </div>
      <div class="nav_menu">
        <div
            id="about_menu"
            class="about_menu"
            :class="{
              'product-menu-border': navMenuIndex === 2,
              'about-menu-layout': navMenuIndex === 0
            }"
            v-if="!pcBarOpenState && navMenuIndex < 3 && navMenuIndex != -1"
        >
          <!-- About Us 菜单布局 -->
          <div v-if="navMenuIndex === 0" class="about_menu_text_only">
            <div
                v-for="(item, index) in nav_title_list[navMenuIndex].children"
                :key="index"
                class="about_menu_item"
                :class="{ 'about-menu-item-active': aboutSelectIndex == index }"
                @mouseenter="aboutEnter(index)"
                @mouseleave="aboutLeave"
                @click="scrollNavto(item.path, item.tag)"
            >
              <span class="menu-text">{{ item.title }}</span>
              <span class="menu-arrow" v-show="aboutSelectIndex == index">></span>
            </div>
          </div>

          <!-- Solutions 菜单布局 -->
          <div v-else-if="navMenuIndex === 1" class="solutions_menu_layout">
            <!-- 左侧文字列表 -->
            <div class="solutions_menu_left">
              <div
                  v-for="(item, index) in nav_title_list[navMenuIndex].children"
                  :key="index"
                  class="about_menu_item"
                  :class="{ 'about-menu-item-active': aboutSelectIndex == index }"
                  @mouseenter="aboutEnter(index)"
              >
                <span class="menu-text">{{ item.title }}</span>
                <span class="menu-arrow" v-show="aboutSelectIndex == index">></span>
              </div>
            </div>

            <!-- 右侧内容区域 -->
            <div class="solutions_menu_right" v-if="aboutSelectIndex !== -1"  @click="scrollNavto(nav_title_list[navMenuIndex].children[aboutSelectIndex].path, nav_title_list[navMenuIndex].children[aboutSelectIndex].tag)">
              <div class="solutions_content_left">
                <h3 class="solution_title">{{ $getI18nField(solutionCategoryData, 'smallTitle') }}</h3>
                <p class="solution_intro">{{ $getI18nField(solutionCategoryData, 'description') }}</p>
                <div class="solution_more_btn">
                  {{ $t('更多') }} ></div>
              </div>
              <div class="solutions_content_right">
                <img v-show="solutionCategoryData.bigImage" :src="solutionCategoryData.bigImage" alt="solution image"/>
              </div>
            </div>
          </div>

          <!-- 其他菜单布局（Products等） -->
          <div v-else class="about_menu_div">
            <div
                v-for="(item, index) in (navMenuIndex === 2 ? productCategories : nav_title_list[navMenuIndex].children)"
                :key="index"
                @mouseenter="aboutEnter(index)"
                @mouseleave="aboutLeave"
                @click="scrollNavto(item.path, item.tag)"
            >
              <img v-if="item.img" :src="aboutSelectIndex == index ? item.blue_img : item.img"/>
              <p :class="{ 'menu-item-active': aboutSelectIndex == index }">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="product_menu" v-if="pcBarOpenState" id="product_menu">
          <div class="product_right_div">
            <div
                class="product_box"
                :class="[$i18n.locale != 'zh' ? 'en' : '']"
                :data-locale="$i18n.locale"
                v-for="(item, index) in nav_title_list"
                :key="index"
            >
              <div
                  v-for="(sub, i) in (item.title === $i18n.t('产品中心') ? productCategories : item.children)"
                  :key="i"
                  @click="scrollNavto(sub.path, sub.tag)"
              >
                <img v-if="sub.img" :src="sub.img" :alt="sub.title"/>
                <p>{{ sub.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
        class="nav-sider"
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
        :modal="false"
        size="100%"
        :direction="direction"
        destroy-on-close
    >
      <div class="drawer-overlay" @click.self="drawer = false">
        <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
        >
          <!-- 递归动态菜单 -->
          <myitem :data="mobile_nav_list"></myitem>
        </el-menu>
      </div>
      <!-- <div class="drawer_search">
        <el-autocomplete
          :placeholder="$t('搜索')"
          suffix-icon="el-icon-search"
          clearable
          v-model="input"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @select="searchAll"
          @clear="hideSearchDiv()"
          @blur="hideSearchDiv()"
        >
        </el-autocomplete>
      </div> -->
    </el-drawer>
  </div>
</template>

<script>
import * as API from "@/api/index";
import sider_open_img from "../../../static/img/nav_open.png";
import sider_open_img2 from "../../../static/img/nav_open2.png";
import sider_close_img from "../../../static/img/nav_close.png";
import barMenuImg from "../../../static/img/change_icon.png";
import barCloseImg from "../../../static/img/change_icon_close.png";
import * as navBar from "./navbar";
import myitem from "./myitem.vue";

export default {
  data() {
    return {
      drawer: false,
      sider_close_img: sider_close_img,
      sider_open_img: sider_open_img,
      sider_open_img2: sider_open_img2,
      active_nav: -1,
      productSelectIndex: -1,
      aboutSelectIndex: -1,
      navMenuIndex: -1,
      navEnterState: false,
      showWhiteNav: false,
      clientWidth: 0,
      isMiniWindows: false,
      product_list: [],
      productCategories: [],
      imgs: [],
      oldScrollTop: 0,
      isHide: false,
      language: "zh",
      input: "",
      showSearch: false,
      pcBarOpenState: false,
      barMenuImg: barMenuImg,
      barCloseImg: barCloseImg,
      showLangDropdown: false,
      direction: "ttb", //ltr从左往右开;rtl从右往左开;ttb从上往下开;btt从下往上开
      solutionCategoryData: {}, // 存储解决方案分类数据
    };
  },
  computed: {
    nav_title_list() {
      return navBar.getList();
    },
    mobile_nav_list() {
      return navBar.getList().map(item => {
        const isProducts = item.title === this.$i18n.t('产品中心');
        const isNews = item.title === this.$i18n.t('新闻资讯');
        const isContact = item.title === this.$i18n.t('联系我们');
        if (isProducts && this.productCategories.length > 0) {
          return { ...item, children: this.productCategories };
        }
        // News 和 Contact Us 直接跳转，不展开子列表
        if (isNews || isContact) {
          return { ...item, children: [] };
        }
        // 非产品中心的子项去掉 img，避免在移动端侧边栏显示图片
        const children = (item.children || []).map(({ img, blue_img, ...rest }) => rest);
        return { ...item, children };
      });
    },
  },
  components: {
    myitem,
  },
  watch: {
    clientWidth(newVal, oldVal) {
      // console.log(newVal); //浏览器窗口变化时，打印宽度。
      if (newVal < 1200) {
        this.isMiniWindows = true;
      } else {
        this.isMiniWindows = false;
      }
      this.setProductMenuLeft();
    },
    "$i18n.locale"() {
      this.getProductCategories();
    },
    $route(to, from) {
      console.log("nav bar to.path==" + to.path);
      this.drawer = false;
      if (to.path == "/Search") {
        for (var i = 0; i < this.nav_title_list.length; i++) {
          var item = this.nav_title_list[i];
          if (from.path.indexOf(item.path) != -1) {
            console.log("from.path==" + item.title);
            this.active_nav = i;
          }
        }
      } else {
        if (to.path == "ProductsDetail") {
          this.showWhiteNav = true;
        } else if (to.path == "/") {
          this.showWhiteNav = false;
        }
        for (var i = 0; i < this.nav_title_list.length; i++) {
          var item = this.nav_title_list[i];
          if (to.path.indexOf(item.path) != -1) {
            console.log("nav bar to.path==" + item.title);
            this.active_nav = i;
            break;
          } else {
            this.active_nav = -1;
          }
        }
      }
      //   var param = this.$route.query.param;
      //   this.path = param;
      //   console.log("param:" + param);
      //   this.navtoPartPath(this.path);
    },
  },
  mounted() {
    this.Init();
    let that = this;
    var clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },

  methods: {
    Init() {
      // 监听页面滚动事件
      window.addEventListener("scroll", this.scrolling);

      // 获取产品分类
      this.getProductCategories();

      let path = window.location.pathname;
      if (path.indexOf("ProductsDetail") != -1) {
        this.showWhiteNav = true;
      }
      // console.log("navbar=="+window.location.pathname)
      for (var i = 0; i < this.nav_title_list.length; i++) {
        var item = this.nav_title_list[i];
        if (path.indexOf(item.path) != -1) {
          console.log("to.path==" + item.title);
          this.active_nav = i;
        } else if (path == "/Search") {
        }
      }
    },
    getProductCategories() {
      API.getProductCategoryList()
          .then((res) => {
            console.log("getProductCategories==" + JSON.stringify(res));
            if (res.code === 0) {
              const list = res.page.list;
              this.productCategories = list.map(category => ({
                title: this.$getI18nField(category, 'title'),
                path: "/Products",
                tag: category.id,
                img: category.image,
                blue_img: category.blueImage,
              }));
            }
          })
          .catch((err) => {
            console.error("获取产品分类失败:", err);
          });
    },
    navEnter() {
      //当是pc端时生效
      if (!this.isMiniWindows) {
        this.navEnterState = true;
      }
    },
    navLeave() {
      this.navEnterState = false;
      this.navMenuIndex = -1;
    },
    navMenuEnter(index) {
      console.log("navMenuIndex==" + index);
      var menu = document.getElementById("about_menu");
      if (menu) {
        menu.style.opacity = 0;
      }

      // 如果是Solutions菜单，默认选中第一个并请求数据
      if (index === 1) {
        this.aboutSelectIndex = 0;
        this.getSolutionCategoryData(1);
      }

      setTimeout(() => {
        var menu = document.getElementById("about_menu");
        if (menu) {
          // Solutions (index=1) 和 Products (index=2) 菜单居中显示
          if (index === 1 || index === 2) {
            menu.style.marginLeft = "auto";
            menu.style.marginRight = "auto";
            menu.style.left = "0";
            menu.style.right = "0";
          } else {
            // About Us (index=0) 等其他菜单需要计算位置对齐
            var obj = document.getElementById("ul_header" + index);
            var obj_self = obj.clientWidth;
            //获取顶部ul_header距离左边边界的距离
            var left = this.getLeftSide("ul_header" + index) + obj_self / 2;
            //设置product_div的margin-left,使其对齐
            var self_width = menu.clientWidth;
            // console.log("self_width", self_width);
            menu.style.marginLeft = left - self_width / 2 + "px";
            menu.style.marginRight = "";
            menu.style.left = "";
            menu.style.right = "";
          }
          // console.log("menu left", menu.offsetLeft);
          menu.style.opacity = 1;
        }
      }, 100);
      this.navMenuIndex = index;
    },
    navMenuLeave() {
      if (this.navMenuIndex === 3) {
        this.navEnterState = false;
        this.navMenuIndex = -1;
      }
    },
    aboutEnter(index) {
      console.log("aboutSelectIndex==" + index);
      this.aboutSelectIndex = index;

      // 如果是Solutions菜单(navMenuIndex === 1)，获取对应的解决方案分类数据
      if (this.navMenuIndex === 1 && index >= 0 && index < 3) {
        const solutionId = index + 1; // id分别为1, 2, 3
        this.getSolutionCategoryData(solutionId);
      }
    },
    aboutLeave() {
      this.aboutSelectIndex = -1;
    },
    productEnter(index) {
      console.log("productEnter==" + index);
      this.productSelectIndex = index;
    },
    productLeave() {
      this.productSelectIndex = -1;
    },
    // 获取解决方案分类数据
    getSolutionCategoryData(id) {
      API.getSolutionCategoryInfo(id)
          .then((res) => {
            if (res.code === 0 && res.solutionCategory) {
              this.solutionCategoryData = res.solutionCategory;
            }
          })
          .catch((err) => {
            console.error("获取解决方案分类失败:", err);
          });
    },
    pcBarOpen() {
      this.pcBarOpenState = !this.pcBarOpenState;
      this.setProductMenuLeft();
    },
    setProductMenuLeft() {
      if (this.pcBarOpenState) {
        setTimeout(() => {
          //获取顶部ul_header距离左边边界的距离
          var left = this.getLeftSide("ul_header");
          //设置product_div的margin-left,使其对齐
          var menu = document.getElementById("product_menu");
          console.log("menu left", menu.offsetLeft);
          menu.style.marginLeft = left + "px";
          menu.style.opacity = 1;
        }, 200);
      }
    },
    getTypeList() {
      API.getProductType()
          .then((res) => {
            var status = res.code;
            if (status === 0) {
              this.product_list = res.data;
              this.nav_title_list[2].children = this.product_list;
            }
          })
          .catch(() => {
          });
    },
    openSider() {
      this.drawer = !this.drawer;
      this.navEnterState = this.drawer;
      this.showWhiteNav = this.drawer;
    },
    navto(path) {
      if (this.isWechat()) {
        this.$router.replace(path).catch(() => {});
      } else {
        // 如果是产品页面，确保不带 param 参数跳转
        if (path === '/Products' && this.$route.path === '/Products') {
          // 已在产品页，移除 param 参数触发 watch
          if (this.$route.query.param) {
            this.$router.push({ path: '/Products' }).catch(() => {});
          }
          return;
        }
        this.$router.push(path).catch(() => {});
      }
    },
    scrollNavto(path, name) {
      this.pcBarOpenState = false;
      this.navMenuIndex = -1;
      // this.isHide = true;

      // 如果路径是解决方案相关的，直接跳转到对应页面
      if (path.startsWith('/Solution')) {
        this.$router.push(path);
      } else {
        // 其他情况使用 query 参数
        this.$router.push({
          path: `${path}`,
          query: {param: name},
        }).catch(() => {});
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    // 头部导航做鼠标滚动优化
    scrolling() {
      // 滚动条距文档顶部的距离（做兼容处理）===》不懂的可以结合画图理清逻辑
      let scrollTop =
          window.scrollY ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      // console.log("oldScrollTop==" + this.oldScrollTop);
      // console.log("scrollStep==" + scrollStep);
      if (!this.drawer && this.oldScrollTop < 120) {
        var url = window.location.href;
        var pathname = window.location.pathname;
        console.log("pathname===", pathname);
        // if(pathname=='/'){

        //   this.showWhiteNav = false;
        // }
        if (url.indexOf("ProductsDetail") != -1) {
          this.showWhiteNav = true;
        } else {
          this.showWhiteNav = false;
        }
        // this.showWhiteNav = false;
      } else {
        this.showWhiteNav = true;
      }
      if (!this.drawer && scrollStep > 0) {
        this.isHide = true;
      } else {
        this.isHide = false;
      }
    },
    toggleLangDropdown() {
      this.showLangDropdown = !this.showLangDropdown;
    },
    selectlang(lang) {
      this.showLangDropdown = false;
      this.language = lang;
      console.log("selectLanguage==", this.language);
      // 根据监听改变获取到的值去数组里找到对应的值
      localStorage.setItem("lang", this.language);
      this.$i18n.locale = this.language; //切换字典文件
      if (this.language == "zh") {
        document.title = this.$route.meta.title;
      } else if (this.language == "en") {
        document.title = this.$route.meta.titleEn;
      } else if (this.language == "es") {
        document.title = this.$route.meta.titleEs || this.$route.meta.titleEn;
      }
      // 刷新页面以重新获取数据
      location.reload();
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    showSearchDiv() {
      this.showSearch = true;
    },
    hideSearchDiv() {
      console.log("hideSearchDiv");
      if (!this.input) {
        this.showSearch = false;
      }
    },
    searchAll(item) {
      console.log("searchAll==");
      if (item.type == 1) {
        //产品
        this.navto("/ProductsDetail/id=" + item.id);
      } else {
        this.navto("/NewsDetail/id=" + item.id);
      }
    },
    querySearch(queryString, cb) {
      if (queryString) {
        console.log("querySearch==", queryString);
        var types = [];
        var data = {
          key: this.input,
          page: 1,
          limit: 999,
        };
        API.getAllList(data)
            .then((res) => {
              var status = res.code;
              if (status === 0) {
                types = res.data.list;
                cb(types);
              }
            })
            .catch(() => {
            });
      }
    },
    //获取距离浏览器左边的距离
    getLeftSide(obj) {
      var su = document.getElementById(obj);
      var leftOffset = su.offsetLeft;
      console.log(obj + ":left offset", leftOffset);
      return leftOffset;
    },
  },
  created() {
    // 获取缓存的语种，如若没有（新用户），保存当前默认语言
    if (localStorage.getItem("lang")) {
      console.log(localStorage.getItem("lang"));
    } else {
      localStorage.setItem("lang", this.language);
    }
    this.language = localStorage.getItem("lang");
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.scrolling);
  },
  updated() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.language-switcher {
  position: relative;
  display: inline-block;
}

.lang-icon {
  width: 2.5rem !important;
  height: 2.5rem !important;
  cursor: pointer;
  vertical-align: middle;
}

.lang-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 100px;
}

.lang-option {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  text-align: center;
}

.lang-option:hover {
  background: #f5f5f5;
  color: #1890ff;
}

.drawer-overlay {
  height: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 1),rgba(255, 255, 255, 1),rgba(255, 255, 255, 1),rgba(255, 255, 255, 0.8),rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0)) !important;
}

.drawer_search {
  width: 100%;
  padding: 5rem 3rem;

  .el-autocomplete {
    width: 100%;
  }
}

.menu-item-active {
  color: #1D2087 !important;
}

.product-menu-border {
  //border-left: 1px solid #E7E8EA;
  //border-right: 1px solid #E7E8EA;
  //border-bottom: 1px solid #E7E8EA;
}

// About Us 菜单样式
.about-menu-layout {
  padding: 20px 0;
}

.about_menu_text_only {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  padding: 0 0 0 9.5rem;
}

.about_menu_item {
  display: flex;
  //justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0 !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.about_menu_item .menu-text {
  font-size: 1.6rem;
  color: #8A9099;
  transition: color 0.3s ease;
  font-family: regular;
}

.about_menu_item .menu-arrow {
  font-size: 1.6rem;
  color: #1D2087;
  margin-left: 12px;
  font-family: regular;
}

.about-menu-item-active .menu-text {
  color: #1D2087 !important;
}

// Solutions 菜单样式
.solutions_menu_layout {
  display: flex;
  padding: 20px 0;
  height: 19rem;
  width: 100vw;
  margin: 5.4rem 12.5% 0;
}

.solutions_menu_left {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  padding: 0 24px;
  border-right: 1px solid #E7E8EA;
}

.solutions_menu_right {
  display: flex;
  flex: 1;
  padding: 0 40px;
  margin-left: 7rem;
  justify-content: space-between;

}

.solutions_content_left {
  display: flex;
  width:59rem;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 20px;
}

.solution_title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #020202;
  margin: 0 0 16px 0;
  font-family: bold;
}

.solution_intro {
  font-size: 1.6rem !important;
  color: #212121 !important;
  line-height: 2.2rem;
  margin: 0 0 4rem 0 !important;
  text-align: left;
  font-family: regular;
}

.solution_more_btn {
  padding: 0.5rem 1.5rem 0.1rem!important;
  color: #9CCF86;
  border: 1px solid #9CCF86;
  border-radius: 3rem;
  font-size: 1.6rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: regular;
}

.solution_more_btn:hover {
  background: #9CCF86;
  color: #fff;
}

.solutions_content_right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.solutions_content_right img {
  width: 36rem !important;
  height: 19rem !important;
  object-fit: contain;
}

// Products 菜单样式
.about_menu_div {
  display: flex;
  flex-wrap: wrap;
}

.about_menu_div > div {
  width: 17.7rem;
  height: 21.4rem;
  line-height: 1.2;
  padding: 0 2rem 0 !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  transition: all 0.3s ease;
  border-right: 1px solid #E7E8EA;
}

.about_menu_div > div img {
  width: 10rem;
  height: 8rem;
  object-fit: contain;
  margin-bottom: 1rem;
  margin-top: 4rem;
}

.about_menu_div > div p {
  font-size: 1.6rem;
  color: #212121;
  text-align: center;
  transition: color 0.3s ease;
  font-family: regular;
  margin: 0;
}

.about_menu_div > div:hover p {
  color: #1D2087;
}

// pcBarOpen 展开菜单中产品子项样式
.product_box > div {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.6rem 0;
  transition: color 0.3s ease;
}

.product_box > div img {
  width: 2.4rem;
  height: 2.4rem;
  object-fit: contain;
  margin-right: 0.8rem;
  flex-shrink: 0;
}

.product_box > div p {
  margin: 0;
  font-size: 1.4rem;
  color: #212121;
  transition: color 0.3s ease;
}

.product_box > div:hover p {
  color: #1D2087;
}

</style>
